import { Link } from "react-router-dom";

import { AppShell } from "../components/AppShell";
import { LEGAL_CONFIG } from "../config/legalConfig";
import { useAuth } from "../hooks/useAuth";

const ROLE_LABELS = {
  INSTITUTION_OFFICER: "Institution officer",
  ORGANISATION_OFFICER: "Organisation officer",
};

/**
 * An officer sign-in that no institution or organisation belongs to (left by
 * an older two-step sign-up, whose details step no longer exists). As in the
 * app, the account shows its details and its settings, nothing else.
 */
export function AccountNotLinkedPage() {
  const { user } = useAuth();

  return (
    <AppShell maxWidth={720}>
      <div className="mx-auto max-w-xl rounded-xl border border-[#E4E8EF] bg-white p-6 sm:p-8">
        <h1 className="text-lg font-bold text-slate-900">Your account</h1>
        <p className="mt-3 text-sm font-semibold text-slate-900 break-words">
          {user?.email}
        </p>
        <p className="text-sm text-slate-600">
          {ROLE_LABELS[user?.type] ?? "Officer"}
        </p>
        <p className="mt-4 text-sm text-slate-600">
          This sign-in is not linked to an institution or organisation. Write to{" "}
          <a
            href={`mailto:${LEGAL_CONFIG.supportEmail}`}
            className="font-semibold text-slate-900 underline"
          >
            {LEGAL_CONFIG.supportEmail}
          </a>{" "}
          from this address and we will sort it out.
        </p>
        <Link
          to="/change-password"
          className="mt-5 inline-block rounded-lg border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50"
        >
          Change password
        </Link>
      </div>
    </AppShell>
  );
}
